<template>
  <div class="controlContainer">
    <div class="mb-3">
      <span v-if="hasMultiLocations()" class="quick-button-title">Hurtigknapper for</span>
      <span v-else class="quick-button-title">Hurtigknapper</span>
      <span v-if="hasMultiLocations()" class="ms-2">
        <select v-model="locationId">
          <option v-for="(location, index) in locations" :key="index" :value="location.id">{{ location.name }}</option>
        </select>
      </span>
    </div>

    <div class="d-flex flex-wrap">
      <div v-for="ot in visibleOnlineOrderTypes" :key="ot.orderType">
          <div>
            <div v-if="isClosedToday(ot.orderType)" class="messageAfterActivated"> {{ ot.nameCap }} stengt </div>
            <div v-else class="messageAfterActivated"> &nbsp; </div> <!-- just make GUI look good -->
          </div>
          <div class="me-2">
            <button v-if="!isClosedToday(ot.orderType)" type="button" class="bo_btn" @click="goToCloseOnlinePage(ot)">Steng {{ ot.name }}</button>
            <button v-else type="button" class="bo_btn" @click="goToOpenOnlinePage(ot)">Åpne {{ ot.name }}</button>
          </div>
      </div>
      <div>
          <div>
            <div class="earliestPickupTime"> {{ useManualPickupOrDeliveryTime ? 'Hentetid: ' + earliestPickupTime + ' min.' : 'Smart: ' + earliestPickupTime + '+ min.' }} </div>
          </div>
          <div class="me-2">
            <button type="button" class="bo_btn" @click="goToChangeEarliestPickupTimePage()">Tidligst hentetid</button>
          </div>
      </div>
      <div>
        <div class="me-2">
          <div class="messageAfterActivated"> &nbsp; </div> <!-- just make GUI look good -->
          <div>
            <button type="button" class="bo_btn" @click="goToSoldOutPage()">
              Utsolgt<span :class="soldOutItemsCount() > 0 ? 'anySoldOut' : ''"> ({{ soldOutItemsCount() }})</span>
            </button>
          </div>
        </div>
      </div>
      <div v-if="customActions">
        <div v-for="(action, index) in customActions" :key="index" class="me-2">
          <div v-if="showMessageAfterActivated(action)" class="messageAfterActivated"> {{ action.closedMessage }} </div>
          <div v-else class="messageAfterActivated"> &nbsp; </div> <!-- just make GUI look good -->
          <button v-if="!showMessageAfterActivated(action)" type="button" class="bo_btn" @click="goToCloseDishesPage()">{{ action.closeName }}</button>
          <button v-else type="button" class="bo_btn" @click="goToOpenDishesPage()">{{ action.openName }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MerchantUtil from "@/util/MerchantUtil";
import moment from "moment";
import LocationUtil from "@/util/LocationUtil";

export default {
  props: {
    locations: Array,
    closingDaysArray: Array,
    categories: Array,
    soldOutItems: Array
  },
  data() {
    return {
      locationId: '',
      // The three online order types that can be closed independently.
      // PICKUP = takeaway, DINE_IN = QR-bestilling, DELIVERY = levering.
      onlineOrderTypes: [
        { orderType: 'PICKUP', name: 'takeaway', nameCap: 'Takeaway' },
        { orderType: 'DINE_IN', name: 'QR-bestilling', nameCap: 'QR-bestilling' },
        { orderType: 'DELIVERY', name: 'levering', nameCap: 'Levering' }
      ]
    };
  },
  computed: {
    merchant(){
        return MerchantUtil.getMerchant();
    },
    selectedLocation(){
      for (let i = 0; i < this.locations.length; i++) {
        if(this.locations[i].id == this.locationId){
          return this.locations[i];
        }
      }
      return null;
    },
    visibleOnlineOrderTypes(){
      let location = this.selectedLocation;
      let offersQR = !!location && (location.offerQR === true || location.offerQR === 'true');
      let offersDelivery = !!location && (location.offerDeliveryService === true || location.offerDeliveryService === 'true');
      //Hide a toggle when the selected location doesn't offer that order type (offerQR / offerDeliveryService).
      return this.onlineOrderTypes.filter(ot => {
        if(ot.orderType === 'DINE_IN'){ return offersQR; }        //QR-bestilling
        if(ot.orderType === 'DELIVERY'){ return offersDelivery; } //levering
        return true;                                              //takeaway always shown
      });
    },
    earliestPickupTime(){
      for (let i = 0; i < this.locations.length; i++) {
        let location = this.locations[i];
        if(location.id == this.locationId){
          return location.earliestPickupTime;
        }
      }
      return 0;
    },
    useManualPickupOrDeliveryTime(){
      for (let i = 0; i < this.locations.length; i++) {
        let location = this.locations[i];
        if(location.id == this.locationId){
          return location.useManualPickupOrDeliveryTime || false;
        }
      }
      return false;
    },
    customActions(){
      for (let i = 0; i < this.locations.length; i++) {
        let location = this.locations[i];
        if(location.id == this.locationId){
          return location.customActions;
        }
      }
      return undefined;
    }
  },
  mounted() {
    const savedLocationId = localStorage.getItem('controlPanelLocationId');
    if (savedLocationId && this.locations.find(loc => loc.id == savedLocationId)) {
      this.locationId = savedLocationId;
    } else {
      this.locationId = this.locations.length ? this.locations[0].id : '';
    }
  },
  watch: {
    locationId(newLocationId) {
      if (newLocationId) {
        localStorage.setItem('controlPanelLocationId', newLocationId);
      }
    }
  },
  methods: {
    hasMultiLocations(){
      return LocationUtil.hasMultiLocations();
    },

    soldOutItemsCount(){
      let count = 0;
      for (let i = 0; i < this.soldOutItems.length; i++) {
        let soldOutItem = this.soldOutItems[i];
        if(soldOutItem.locationId == this.locationId){
          count++;
        }
      }
      return count;
    },

    isClosedToday(orderType){
      let today = moment(new Date());
      for (let i = 0; i < this.closingDaysArray.length; i++) {
        let closingDays = this.closingDaysArray[i];
        if(closingDays.locationId == this.locationId && this.closingDayAppliesToOrderType(closingDays, orderType)){
          let fromDate = moment(closingDays.fromDate)
          let toDate = moment(closingDays.toDate)
          //Docs: http://momentjs.com/docs/#/query/is-between/
          if(moment(today.format('YYYY-MM-DD')).isBetween(fromDate.format('YYYY-MM-DD'), toDate.format('YYYY-MM-DD'), null, '[]')){
            return true;
          }
        }
      }
      return false;
    },
    //A closing day applies to an order type when closedForOrderTypes is missing/empty (legacy = closes all) or contains the order type.
    closingDayAppliesToOrderType(closingDay, orderType){
      if(!closingDay.closedForOrderTypes || closingDay.closedForOrderTypes.length === 0){
        return true;
      }
      return closingDay.closedForOrderTypes.includes(orderType);
    },
    showMessageAfterActivated(action){
      let activated = true;
      if(action.actionType === 'CLOSE_OPEN_DISHES'){
        //Check all categories
        for (let i = 0; i < action.categoryIds.length; i++) {
          let categoryId = action.categoryIds[i];
          let category = this.getCategory(categoryId);
          let availableAtLocationIds = category.availableAtLocationIds;
          for (let x = 0; x < availableAtLocationIds.length; x++) {
              if(this.locationId == availableAtLocationIds[x]){ //available at this location
                activated = false;
                break;
              }
          }
        }
      }
      return activated;
    },
    getCategory(categoryId){
      for (let i = 0; i < this.categories.length; i++) {
        let category = this.categories[i];
        if(category.id == categoryId){
          return category;
        }
      }
      return null;
    },
    goToCloseOnlinePage(ot){
      this.$router.push({ path: 'closeOnline', query: {locationId: this.locationId, orderType: ot.orderType, label: ot.name} });
    },
    goToOpenOnlinePage(ot){
      this.$router.push({ path: 'openOnline', query: {locationId: this.locationId, orderType: ot.orderType, label: ot.name} });
    },
    goToChangeEarliestPickupTimePage() {
      this.$router.push({ path: 'changeEarliestPickupTime', query: {locationId: this.locationId} });
    },
    goToSoldOutPage() {
      this.$router.push({ path: 'soldOut', query: {locationId: this.locationId} });
    },
    goToCloseDishesPage(){
      this.$router.push({ path: 'closeDishes', query: {locationId: this.locationId} });
    },
    goToOpenDishesPage(){
      this.$router.push({ path: 'openDishes', query: {locationId: this.locationId} });
    }
  }
}
</script>

<style scoped>
.controlContainer{
  background-color: var(--bo-line);
  padding-top: 10px;
  padding-bottom: 20px;
}

.quick-button-title{
  font-weight: bold;
  font-size: 17px;
  margin-bottom: 15px;
}

.quick-button{
  margin-left: 10px;
}

.messageAfterActivated{
  margin-top: 10px;
  margin-left: 10px;
  color: #dd143b;
}

.earliestPickupTime{
  margin-top: 10px;
  margin-left: 5px;
  color: var(--bo-success-ink);
}
</style>
